import { RoutePathsEnum } from "infrastructure/RoutePathsEnum";
import { GlobalState } from "little-state-machine";

export const updateViewWorkOrderPageOrigination = (
  state: GlobalState,
  viewWorkOrderPageOrigination
  : RoutePathsEnum
) => ({
  ...state,
  viewWorkOrderPageOrigination
});
